export const PACKAGE_VERSION = '1.7.8';
//# sourceMappingURL=constants.js.map